<template>
<section id="clAdvantages">
  <h2 class="instH2">Как работает кредитная линия</h2>
  <ul>
    <li>
      <p>Срок 10 лет</p>
      <p>Оформите один раз, и деньги будут доступны весь срок действия договора</p>
    </li>
    <li>
      <p>Деньги доступны при необходимости</p>
      <p>Можно брать несколько сумм в пределах лимита</p>
    </li>
    <li>
      <p>Проценты только за то, что используете</p>
      <p>Платите проценты только за то, что получили</p>
    </li>
  </ul>
  <instApplyButton></instApplyButton>
</section>
</template>

<script>
export default {
  name: "clAdvantages",
  components: {
    instApplyButton: () => import('@/components/inst/instApplyButton.vue'),
  }
}
</script>

<style scoped>
ul{background: white;padding: var(--font-size-40) var(--font-size-20);border-radius: var(--font-size-20);font-family: 'Roboto';}
li{border-radius: var(--font-size-20);background: var(--color-gray-type4);padding: var(--font-size-20) var(--font-size-24);margin: 0 auto var(--font-size-20);}
li:last-child{margin-bottom: 0;}
li p:first-child{font-weight: 500;font-size: var(--font-size-18);margin-bottom: var(--font-size-10)}
li p:last-child{font-weight: 100;font-size: var(--font-size-16);color:var(--color-gray-type3);}

@media screen and (min-width: 760px) {
  ul{display: flex;align-items: stretch;justify-content: flex-start;padding: var(--font-size-40);gap: var(--font-size-15);}
  li{width: calc((100% - (var(--font-size-15) * 2)) / 3);margin: 0;}
}
</style>
